import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination-controls',
  templateUrl: './pagination-controls.component.html',
  styleUrls: ['./pagination-controls.component.css']
})
export class PaginationControlsComponent implements OnInit {
  @Input() currentPageNumber: number;
  @Input() totalPages: number;
  @Input() index: number = 0;
  @Input() environment: number;
  @Output() callback = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    this.ConverttoNumber();

  }

  btnClick_nextdynamic() {
    if (this.currentPageNumber == this.totalPages || this.currentPageNumber == 0) {

    } else {
      if (this.currentPageNumber == 1) {
        this.index = 0;
      }

      this.currentPageNumber = Number(this.currentPageNumber) + 1;
      this.index += Number(this.environment);
      this.ConverttoNumber();

      this.callback.emit({ currentPageNumber: this.currentPageNumber, totalPages: this.totalPages, index: this.index });
    }
   

  }


  btnClick_previousdynamic() {
    if (this.currentPageNumber == 1 || this.currentPageNumber == 0) {
    } else {
      this.currentPageNumber -= 1;
      this.index -= this.environment
      this.ConverttoNumber();

      this.callback.emit({ currentPageNumber: this.currentPageNumber, totalPages: this.totalPages, index: this.index });
    }
   

  }


  btnClick_firstdynamic() {
    if (this.currentPageNumber == 1 || this.currentPageNumber == 0) {
    } else {
      this.currentPageNumber = 1;
      this.index = 0;
      this.ConverttoNumber();

      this.callback.emit({ currentPageNumber: this.currentPageNumber, totalPages: this.totalPages, index: this.index });
    }
 

  }

  btnClick_lastdynamic() {
    if (this.currentPageNumber == this.totalPages || this.currentPageNumber == 0) {
    } else {
      this.currentPageNumber = this.totalPages;
      var total = this.totalPages - 1;
      this.index = this.environment * total;

      this.ConverttoNumber();

      this.callback.emit({ currentPageNumber: this.currentPageNumber, totalPages: this.totalPages, index: this.index });
    }
   

  }

  ConverttoNumber() {
    this.currentPageNumber = Number(this.currentPageNumber);
    this.totalPages = Number(this.totalPages);
    this.index = Number(this.index);
    this.environment = Number(this.environment);
  }


}
